import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/climate-systems")({
  head: () => ({
    meta: [
      { title: pageTitle("Climate & Systems", "en") },
      { name: "description", content: "Essays on climate, energy and the planetary systems that keep the biosphere standing." },
      { property: "og:title", content: "Climate & Systems — Smart Sustainability" },
      { property: "og:description", content: "Essays on climate and planetary systems." },
      { property: "og:url", content: "https://smartsustainability.ai/climate-systems" },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "tr_TR" },
    ],
    links: [
      { rel: "canonical", href: "https://smartsustainability.ai/climate-systems" },
      ...hreflangLinks("/iklim-sistemleri", "/climate-systems"),
    ],
  }),
  loader: () => getAllPosts(),
  component: ClimatePage,
});

function ClimatePage() {
  const { t } = useT();
  const { articles: posts } = useLocalizedPosts(Route.useLoaderData());
  return (
    <CategoryPage
      category={t("cat.climate.title")}
      tagline={t("cat.climate.tagline")}
      essays={posts.filter((p) => String(p.category) === "Climate & Systems" || String(p.category) === "İklim & Sistemler")}
    />
  );
}
